export const LAST_UPDATE_STATS_STORAGE_KEY = "last_update_stats_ms";

export function readLocalLastUpdateStatsMs(): number {
  try {
    const raw = localStorage.getItem(LAST_UPDATE_STATS_STORAGE_KEY);
    if (!raw) {
      return 0;
    }
    const ms = Number(raw);
    return Number.isFinite(ms) && ms >= 0 ? Math.floor(ms) : 0;
  } catch {
    return 0;
  }
}

export function writeLocalLastUpdateStatsMs(ms: number): void {
  const value = Number.isFinite(ms) && ms >= 0 ? Math.floor(ms) : 0;
  try {
    if (value <= 0) {
      localStorage.removeItem(LAST_UPDATE_STATS_STORAGE_KEY);
      return;
    }
    localStorage.setItem(LAST_UPDATE_STATS_STORAGE_KEY, String(value));
  } catch {
  }
}

export function clearLocalLastUpdateStatsMs(): void {
  try {
    localStorage.removeItem(LAST_UPDATE_STATS_STORAGE_KEY);
  } catch {
  }
}
